<step3-popup #edit></step3-popup>
<app-project-finish-assignmento  #finishAssign></app-project-finish-assignmento>
<div class="container-fluid componente-importantes text-start p-5 mt-3" >
        <section class="">
          <form class="row d-flex justify-content-between" action="" method="post" (submit)="formSubmit()"
            [formGroup]="Step3form">
            <div class="col">
              <label for="formControlInput" class="form-label ">Usuario</label>
              <select required class="custom-outline-input form-select " formControlName="user_id"
                aria-label="Default select">
                <option selected value=""> Seleccione...</option>
                <option *ngFor="let item of listUser" [value]="item.id">{{item.username}}</option>
              </select>
            </div>
            <div class="col">
              <label for="formControlInput" class="form-label ">Rol</label>
              <select required class="custom-outline-input form-select" formControlName="type_id"
                aria-label="Default select">
                <option selected value=""> Seleccione...</option>
                <option *ngFor="let item of listType" [value]="item.id">{{item.name}}</option>
              </select>
            </div>
            <div class="col">
              <label for="formControlInput" class="form-label">Fecha inicio</label>
              <input required type="date" class="custom-outline-input  date" formControlName="start_date"
                id="start_date">
            </div>
            <div class="col">
              <label for="formControlInput" class="form-label">Fecha termino</label>
              <input required type="date" class="custom-outline-input date" formControlName="end_date"
                id="end_date">
            </div>
            <div class="col">
              <label for="formControlInput" class="form-label">% de asignación</label>
              <input required type="text" placeholder="Ingrese información" formControlName="assigned"
                class="custom-outline-input" id="formControlInput">
            </div>
            <div class="col d-flex justify-content-end align-items-end">
              <button [disabled]="!Step3form.valid" class="form-control btn btn-outline-light "> <i
                  class="fa-solid fa-floppy-disk m-1" aria-hidden="true"></i> Añadir</button>

            </div>

          </form>

        </section>
        <section class="backgroundTable row mx-2 mt-5 pb-5">
            <div class="col-12 ">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes">
                    <thead>
                        <tr >
                            <th class="text-center">Avatar</th>
                            <th class="text-white text-center" >Usuario</th>
                            <th class="text-white text-center" >Rol</th>
                            <th class="text-white text-center" >Estado Asignacion</th>
                            <th class="text-white text-center" >% asignación</th>
                            <th class="text-white text-center" >Fecha inicio</th>
                            <th class="text-white text-center" >Fecha fin</th>
                            <th class="text-white text-center" >Opciones</th>
                       
                    </thead>
                    <tbody>
            <tr *ngFor="let item of listAssigned">

              <td class="text-center">

                <div class="d-flex justify-content-center bd-highlight mb-2">
                    <div class="p-2 bd-highlight">
                        <img src={{item.url}} class="img-fluid badge-img-radio" alt=""> 
                    </div>
                  </div>
                </td>


              <td class="text-center" >{{item.username}}</td>
              <td class="text-center"> {{item.name}} </td>
              <td class="text-center">
                <div class="p-2 bd-highlight">
                  <span *ngIf="item.assignation_status === 1"
                    class="badge rounded-pill text-bg-success p-2" style="font-size: 12px;">Activo</span>
                  <span *ngIf="item.assignation_status === 2"
                    class="badge rounded-pill text-bg-info p-2 " style="font-size: 12px;">Terminada</span>
                  </div>
              </td>
              <td class="text-center">
                {{item.allocation}} %
              </td>
              <td class="text-center">{{item.start}}</td>
              <td class="text-center">{{item.end}}</td>
              <td class="text-center"> 

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button ngbDropdownItem (click)="edit.open(item,listType)"   >Editar</button>
                    <button ngbDropdownItem  *ngIf="crud=='edit' && item.assignation_status == 1"  (click)="finishAssign.open(item.end,item.id)"  >Terminar Asginacion</button>
                    <button ngbDropdownItem  *ngIf="crud=='edit' && item.assignation_status == 2"  (click)="stageActivate(item.id)" >Activar</button>
                    <button ngbDropdownItem (click)="stageDelete(item.id)" >Eliminar</button>
                  </div>
                </div>
              </td>
   
            </tbody>
                </table>
            </div>
            
        </section>
    </div>